<template>
  <div class="RotateAllert">
    <div class="container">
      <img :src="`${baseUrl}images/svg/rotate.svg`" />
      <div class="title">Please rotate your device</div>
      <div class="dida">We support portrait mode only</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>
<style lang="scss" scoped>
.RotateAllert {
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  align-self: center;
  justify-content: center;
  background: $black;
  color: $white;
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .title {
      @include overlayM;
      text-transform: uppercase;
      margin: 35px 0 10px;
    }
    .dida {
      @include pS;
    }
  }
  @media (orientation: portrait) {
    display: none;
  }
  @media (orientation: landscape) {
    display: flex;
  }
}
</style>